import SERVICE_URL from "../config/API_DATA"
import BaseConfiguration from "../config/base.js"
import HttpPost from "../http/httppost.js";
import Logger from './logger.js';

import {
    LOG_TYPE,
    FILE_NAME
} from "../config/API_DATA";
import { TRIP } from "../util/constants";
export default class PricingSearch {
    static buildRequest(pSessionId, pSelFlight,pSearchStoreObj) {
        if (BaseConfiguration.isDebug) console.log("buildRequest");

        let returnValue = null;

        try {
            let retBody = this.formatPricingBody(pSessionId, pSelFlight,pSearchStoreObj);
            let body = retBody;

            returnValue = body;
        } catch (err) {
            let body = Logger.buildRequest(FILE_NAME.API_PRICING_SEARCH, "error in building body for pricing Search api", err.toString(), "buildRequest", LOG_TYPE.ERROR);
            Logger.getResponse(body);
        }
        return returnValue;
    }

    static async getResponse(pReqOptions) {
        if (BaseConfiguration.isDebug) console.log("getResponse");

        let returnValue = null;
        try {

            returnValue = await HttpPost.makeHttpPostRequest(SERVICE_URL.GET_PRICING_SEARCH, pReqOptions);

        } catch (err) {

            let body = Logger.buildRequest(FILE_NAME.API_PRICING_SEARCH, "error in getting Response from  pricing search api ", err.toString(), "getResponse", LOG_TYPE.ERROR);
            Logger.getResponse(body);
        }
        // console.log(returnValue);
        return returnValue;

    }
    static formatPricingBody(pSessionId, pSelFlight,pSearchStoreObj) {
        try {
            if (BaseConfiguration.isDebug) console.log("formatPricingBody");
            let pricingFormat = {
                sessionId: null,
                pId: []
            };
            let pIdList = [];
            if (pSelFlight) {
                if(pSelFlight.constructor==Object){
                    if (pSelFlight.ob) {
                        pIdList.push(pSelFlight.ob.pId);
                    } if (pSelFlight.ib) {
                        pIdList.push(pSelFlight.ib.pId);
                    }
                }else{
                    for(let i=0;i<pSelFlight.length;i++){
                        pIdList.push(pSelFlight[i].pId);
                    }
                }
                
            }
            pricingFormat.pId = pIdList;
            if (pSessionId) {
                pricingFormat.sessionId = pSessionId;
            }
            return pricingFormat;
        } catch (err) {

            let body = Logger.buildRequest(FILE_NAME.API_PRICING_SEARCH, "error in formatPricingBody ", err.toString(), "formatPricingBody", LOG_TYPE.ERROR);
            Logger.getResponse(body);
        }
    }

}